export const environment = {
    production: false,
    apiUrl: "https://dev-posible-api.gilasw.com/"
};
